import React from "react";
import { motion } from "framer-motion";

// User-supplied photomontage — amber/gold cinematic collage, rendered as the
// central 3D "AI Agent" hologram centerpiece per the design blueprint fusing
// cyberpunk-neon rim lighting with liquid-metal clarity. Served locally as a
// compressed WebP (~80KB, down from a 2.5MB source PNG) for fast loads.
export const HOLOGRAM_IMG = "/hologram-utsav.webp";

export function HologramPortrait({ className = "", label = "UTSAV · AI AGENT", showLabel = true, testId = "hologram-portrait" }) {
    return (
        <motion.div
            data-testid={testId}
            className={`relative select-none pointer-events-none ${className}`}
            animate={{ y: [0, -14, 0] }}
            transition={{ repeat: Infinity, duration: 6, ease: "easeInOut" }}
        >
            {/* Concentric hologram rim rings — Blue/Red/Amber cinematic fusion */}
            <span className="absolute inset-0 rounded-full border border-cyan-400/35" style={{ animation: "vfxPulse 5s ease-in-out infinite" }} />
            <span className="absolute -inset-3 rounded-full border border-rose-500/20" style={{ animation: "vfxPulse 6.5s ease-in-out 0.5s infinite" }} />
            <span className="absolute -inset-6 rounded-full border border-amber-400/15" style={{ animation: "vfxPulse 8s ease-in-out 1s infinite" }} />

            <div
                className="relative w-full h-full rounded-full overflow-hidden border border-white/15"
                style={{ boxShadow: "0 0 90px rgba(255,184,0,0.22), 0 0 140px rgb(var(--accent-1-rgb) / 0.14), inset 0 0 60px rgba(0,0,0,0.5)" }}
            >
                <img
                    src={HOLOGRAM_IMG}
                    alt="Utsav Mukherjee — UTSAVA Genesis AI Agent"
                    className="w-full h-full object-cover"
                    style={{
                        WebkitMaskImage: "radial-gradient(circle at 50% 40%, black 60%, transparent 94%)",
                        maskImage: "radial-gradient(circle at 50% 40%, black 60%, transparent 94%)",
                        filter: "contrast(1.12) brightness(1.08) saturate(1.08)",
                        mixBlendMode: "screen",
                    }}
                />
                {/* Scanlines — HUD/hologram texture */}
                <div
                    className="absolute inset-0 pointer-events-none opacity-30"
                    style={{ backgroundImage: "linear-gradient(rgba(255,255,255,0) 50%, rgba(0,0,0,0.35) 50%)", backgroundSize: "100% 4px" }}
                />
                {/* Cinematic dual-tone light flares */}
                <div
                    className="absolute inset-0 pointer-events-none mix-blend-overlay"
                    style={{ background: "radial-gradient(ellipse at 22% 12%, rgb(var(--accent-1-rgb) / 0.4), transparent 55%), radial-gradient(ellipse at 82% 88%, rgb(var(--accent-3-rgb) / 0.28), transparent 55%)" }}
                />
                {/* Bottom fade — blends the collage edge into the surrounding surface */}
                <div className="absolute inset-x-0 bottom-0 h-1/3 pointer-events-none" style={{ background: "linear-gradient(180deg, transparent, rgba(5,5,10,0.7))" }} />
            </div>

            {showLabel && (
                <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 panel px-3 py-1 backdrop-blur-md bg-[var(--bg-elevated)]/85 whitespace-nowrap z-10">
                    <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-cyan-300">{label}</span>
                </div>
            )}
        </motion.div>
    );
}
